module.exports = __webpack_public_path__ + "img/966-bb3b5f.png";